import { DEBUG } from "../../env";
let ROUTE = null;
if (DEBUG) {
    ROUTE = "http://iea-api.test/api/app/";
    // ROUTE = "https://api.sistemaiea.com/api/app/";
     //ROUTE = "http://localhost:8000/api/app/";
   // ROUTE = "http://localhost:8000/api/app/";
} else {
  ROUTE = "https://devapi.testingiea.com/api/app/";
}
export default ROUTE;
